import { useZakelijkOrder } from "app/hooks/payment/useZakelijkOrder";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

interface ProductsTotalProps {
  className?: string;
}

const ZakelijkPaymentProductsTotal = ({
  className = "",
}: ProductsTotalProps) => {
  // Fetch total price and VAT amount from the custom hook
  const { totalPrice, vatAmount } = useZakelijkOrder();

  // Total text to display
  const totalText = "Totaal incl. BTW";

  const totalFormattedPrice = getFormattedPrice(totalPrice);

  return (
    <>
      <div
        className={concatClassnames(
          className,
          "gg-mt-5 xl:gg-ml-auto xl:gg-mt-2",
        )}
      >
        <Text className="gg-mb-1 gg-text-lg">{totalText}</Text>

        <Text
          data-testid="total-price"
          className="gg-text-3xl sm:gg-text-4xl"
          bold
        >
          {totalFormattedPrice}
        </Text>

        <p className="gg-text-faded-white gg-mt-1 gg-text-xs">
          incl. €{vatAmount} btw
        </p>
      </div>
    </>
  );
};
export default ZakelijkPaymentProductsTotal;
